/**
 * ExportAtomAPI — l'estrazione dei dati verso ATOM (solo ADMIN).
 *
 * ⚠️ Il file NON si scarica con un collegamento.
 *
 * La richiesta ha bisogno dell'intestazione di autenticazione, e un `<a href>` non la
 * porta: il server risponderebbe «non autorizzato» e il browser aprirebbe una pagina di
 * errore al posto del file. Si scarica come dato e si consegna al browser da qui.
 */

const intestazioni = () => ({"x-access-token": localStorage.getItem("hash")});

const periodo = (dal, al) => {
    const pezzi = [];
    if (dal) pezzi.push("dal=" + encodeURIComponent(dal));
    if (al) pezzi.push("al=" + encodeURIComponent(al));
    return pezzi.length ? "?" + pezzi.join("&") : "";
};

/** Quante righe uscirebbero, senza generare niente. */
const conteggio = function (dal, al) {
    return new Promise(function (risolvi, rifiuta) {
        fetch(global.route.exportAtomConteggio + periodo(dal, al), {
            headers: intestazioni(), method: "GET"
        })
            .then((r) => (r.status !== 500) ? r.json() : rifiuta())
            .then((j) => {
                global.checkAuth(j.status);
                if (j.status === "EXPORT_COUNT") risolvi(j);
                else rifiuta(j);
            })
            .catch((e) => {
                console.error(e.message);
                rifiuta("APP_ERROR");
            });
    });
};

/** Genera il file e lo consegna al browser. Torna il nome del file scaricato. */
const scarica = function (dal, al) {
    return new Promise(function (risolvi, rifiuta) {
        fetch(global.route.exportAtom + periodo(dal, al), {
            headers: intestazioni(), method: "GET"
        })
            .then((r) => {
                if (!r.ok) return rifiuta("EXPORT_ERROR");

                /**
                 * ⚠️ Il nome viene dal server, non si ricostruisce qui: sa lui che periodo
                 * ha davvero esportato. Se l'intestazione manca, un nome di ripiego —
                 * meglio un file che si chiama male che un download che non parte.
                 */
                const disposizione = r.headers.get("content-disposition") || "";
                const trovato = disposizione.match(/filename="([^"]+)"/);
                const nome = trovato ? trovato[1] : "cltv-verso-atom.xlsx";

                return r.blob().then((dato) => {
                    const url = window.URL.createObjectURL(dato);
                    const link = document.createElement("a");

                    link.href = url;
                    link.download = nome;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);

                    risolvi(nome);
                });
            })
            .catch((e) => {
                console.error(e.message);
                rifiuta("APP_ERROR");
            });
    });
};

export default {conteggio, scarica};
